module.exports = __webpack_public_path__ + "static/img/low.1c5dc5b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/low.jpeg
// module id = ezyo
// module chunks = 13